<div class="layout-sidebar cb-sidebar-new">
    <!-- Static site context. data-site-switcher marks the future dropdown hook. -->
    <div class="site-context" data-site-switcher>
        <div class="site-context-label">Site</div>
        <div class="site-context-name">{{ siteName() }}</div>
    </div>

    <div class="layout-menu-container h-full">
        <ul class="layout-menu">
            @for (group of groups; track group.key) {
                @let groupItems = itemsByGroup().get(group.key) ?? [];
                @if (groupItems.length > 0) {
                <li class="layout-root-menuitem">
                    @if (group.label) {
                        <div class="layout-menuitem-root-text text-secondary">
                            <span>{{ group.label }}</span>
                        </div>
                    }
                    <ul>
                        @for (item of groupItems; track item.routerLink) {
                            <li>
                                <a [routerLink]="item.routerLink" routerLinkActive="active-route" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }" pRipple>
                                    <i class="layout-menuitem-icon" [ngClass]="item.icon"></i>
                                    <span class="layout-menuitem-text">{{ item.label }}</span>
                                    @if (badgeFor(item) !== undefined && badgeFor(item) !== null) {
                                        <span class="ml-auto">
                                            <p-badge [value]="badgeFor(item)"></p-badge>
                                        </span>
                                    }
                                </a>
                            </li>
                        }
                    </ul>
                </li>
                }
            }
        </ul>
    </div>
</div>
